import { Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CommonTextField from "../../../../../common/components/functional/commonTextField/CommonTextField";
import DateField from "../../../../../common/components/functional/dateField/DateField";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { OrderType } from "../../../orderAPI";
import { FormTitleGrid, FormTitleGridRows } from "../../../styles";
import { isAfter, isBefore, isValid } from "date-fns";

const WORKTIME_LONG_DESCRIPTIONS_MAX_LENGTH = 2000;
const WORKTIME_SHORT_DESCRIPTIONS_MAX_LENGTH = 200;

export const WorkDetails = () => {
  const { t } = useTranslation("order");
  const {
    formState: { errors },
    watch,
    control,
  } = useFormContext();
  const { type, isReadOnly } = watch();

  return (
    <FormSection title={t("employmentDurationAndWorkTime")}>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary">
          {type === OrderType.FixedTerm ? t("startAndEndDate") : t("startDate")}
        </Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <DateField
          name="workStarts"
          disabled={isReadOnly}
          sx={{ maxWidth: "140px" }}
          error={!!errors.workStarts}
          required={{ value: !!watch("workStarts"), message: "" }}
          validate={(value) => {
            return OrderType.FixedTerm
              ? value && isValid(value) && !isAfter(value, watch("workEnds"))
              : value && isValid(value);
          }}
        />
        {type === OrderType.FixedTerm && (
          <>
            <Typography m={1}>{"–"}</Typography>
            <DateField
              name="workEnds"
              disabled={isReadOnly}
              sx={{ maxWidth: "140px" }}
              error={!!errors.workEnds}
              required={{ value: !!watch("workEnds"), message: "" }}
              validate={(value) =>
                !isBefore(watch("workEnds"), watch("workStarts")) &&
                isValid(value)
              }
            />
          </>
        )}
      </Grid>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary">
          {t("shortWorkTimeDescriptionFi")}
        </Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <Controller
          name="shortWorkTimeDescriptionFi"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              placeholder={t("shortWorkTimeDescriptionPlaceholder")}
              inputProps={{ maxLength: WORKTIME_SHORT_DESCRIPTIONS_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
      <FormTitleGridRows item container xs={4}>
        <Typography variant="secondary">
          {t("longWorkTimeDescriptionFi")}
        </Typography>
        <Typography variant="secondary" fontSize={13}>
          {t("optional")}
        </Typography>
      </FormTitleGridRows>
      <Grid item xs={8} display="flex">
        <Controller
          name="longWorkTimeDescriptionFi"
          control={control}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              multiline
              rows={2}
              placeholder={t("longWorkTimeDescriptionPlaceholder")}
              inputProps={{ maxLength: WORKTIME_LONG_DESCRIPTIONS_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
      <FormTitleGridRows container item xs={4}>
        <Typography variant="secondary">
          {t("shortWorkTimeDescriptionEn")}
        </Typography>
        <Typography variant="secondary" fontSize={13}>
          {t("optional")}
        </Typography>
      </FormTitleGridRows>
      <Grid item xs={8} display="flex">
        <Controller
          name="shortWorkTimeDescriptionEn"
          control={control}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              inputProps={{ maxLength: WORKTIME_SHORT_DESCRIPTIONS_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
      <FormTitleGridRows container item xs={4}>
        <Typography variant="secondary">
          {t("longWorkTimeDescriptionEn")}
        </Typography>
        <Typography variant="secondary" fontSize={13}>
          {t("optional")}
        </Typography>
      </FormTitleGridRows>
      <Grid item xs={8} display="flex">
        <Controller
          name="longWorkTimeDescriptionEn"
          control={control}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              inputProps={{ maxLength: WORKTIME_LONG_DESCRIPTIONS_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};
